<template>
    <div>        
        <rotinastarefa :optarefacmp="optarefa" :idtarefacmp="idtarefa"></rotinastarefa>
        <div class="container-fluid draco-dash-shell">
            <div class="draco-dash-header">
                <div class="draco-dash-header-main">
                    <span class="draco-dash-kicker">Painel operacional</span>
                    <h5 class="draco-dash-title">{{ gerarMensagemDeBoasVindas() }}</h5>
                </div>
                <div class="draco-dash-header-actions">
                    <span class="draco-dash-periodo">
                        <i class="fa fa-calendar"></i> {{ displayperiodo }}
                    </span>
                    <button type="button" class="btn btn-light btn-sm draco-dash-btn-periodo" data-toggle="modal" data-target="#mddefinirperiododash">
                        <i class="fa fa-calendar"></i> Selecionar período
                    </button>
                </div>
            </div>
            <div class="row">
                <div v-show="parseInt(usuariologado.cardresumopedidos)===1" style="margin-top: 15px;">
                    <div class="row" style="padding-top: 38px">
                        <!-- Earnings (Monthly) Card Example -->
                        <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card shadow h-100">
                                <div class="card-body">
                                    <button type="button" class="btn btn-primary btn-sm" style="border-radius: 33px!important;
                                    position: absolute;
                                    top: -15px;
                                    left: 0px;">
                                         Total em abertos
                                    </button>
                                    <div class="row no-gutters ">
                                        <div class="col text-right bgness">
                                            <div class="h5  font-weight-bold text-gray-800 mg5">{{ mtdformatavalordecimal(vpedidosabertos) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card">
                                <div class="card-body">
                                    <button type="button" class="btn btn-outline-primary" @click="deffinanceirochart=1">
                                        <i class="fa fa-pie-chart"></i> Gráfico de Pizza
                                    </button>
                                    <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                            <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                                Total em abertos</div>
                                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ mtdformatavalordecimal(vpedidosabertos) }}</div>
                                        </div>
                                        <div class="col-auto">
                                            <i class="fa fa-refresh"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <!-- Earnings (Monthly) Card Example -->
                        <!-- <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card border-left-success shadow h-100 py-2">
                                <div class="card-body">
                                    <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                            <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                                                Total faturados</div>
                                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{  mtdformatavalordecimal(vpedidosfat) }}</div>
                                        </div>
                                        <div class="col-auto">
                                            <i class="fa fa-dollar"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card shadow h-100">
                                <div class="card-body">
                                    <button type="button" class="btn btn-primary btn-sm bgverde" style="border-radius: 33px!important;
                                    position: absolute;
                                    top: -15px;
                                    left: 0px;">
                                         Total faturados
                                    </button>
                                    <div class="row no-gutters ">
                                        <div class="col text-right bgness">
                                            <div class="h5  font-weight-bold text-gray-800 mg5">{{ mtdformatavalordecimal(vpedidosfat) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                         <!-- Pending Requests Card Example -->
                         <!-- <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card border-left-warning shadow h-100 py-2">
                                <div class="card-body">
                                    <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                            <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                                                Pedidos cancelados</div>
                                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ parseInt(qtdcancelados) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card shadow h-100">
                                <div class="card-body">
                                    <button type="button" class="btn btn-primary btn-sm bgvermelho" style="border-radius: 33px!important;
                                    position: absolute;
                                    top: -15px;
                                    left: 0px;">
                                         Pedidos cancelados
                                    </button>
                                    <div class="row no-gutters ">
                                        <div class="col text-right bgness">
                                            <div class="h5  font-weight-bold text-gray-800 mg5">{{ parseInt(qtdcancelados) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- Pending Requests Card Example -->
                        <!-- <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card border-left-warning shadow h-100 py-2">
                                <div class="card-body">
                                    <div class="row no-gutters align-items-center">
                                        <div class="col mr-2">
                                            <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                                Pedidos abertos</div>
                                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ parseInt(qtdabertos) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="col-xl-3 col-md-6 mb-4">
                            <div class="card shadow h-100">
                                <div class="card-body">
                                    <button type="button" class="btn btn-primary btn-sm bgamarelo" style="border-radius: 33px!important;
                                    position: absolute;
                                    top: -15px;
                                    left: 0px;">
                                         Pedidos abertos
                                    </button>
                                    <div class="row no-gutters ">
                                        <div class="col text-right bgness">
                                            <div class="h5  font-weight-bold primary">{{ parseInt(qtdabertos) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardfinanceiro) === 1" class="col-md-12" style="margin-top: 10px;">
                            <div class="card shadow h-100" style="background-color: rgba(255, 255, 255, 0.194); margin: 0; padding: 0;">
                                <div class="card-header card-dash">
                                    <span style="font-size: 18px!important;" class="tit-card-dash">Balanço financeiro</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                           
                                            <graficobarra v-show="deffinanceirochart===0" :titulo="''"
                                                            :agrupamento="legendasfinanceiro"
                                                            :series="dadosfinanceiro"
                                            ></graficobarra>

                                             <graficopie v-show="deffinanceirochart===1"	:titulo="''"
                                                            :subtitulo="''"
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendasfinanceiro"
                                                            :dados="dadosfinanceiro"
                                                            :visualizarlegenda="false"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>

                                            
                                            
                                        </div>
                                        <div class="col-md-12">
                                            <div class="btn-group d-flex justify-content-center" role="group" style="margin-top: 10px;">
                                                <button type="button" class="btn btn-outline-primary" @click="deffinanceirochart=0">
                                                    <i class="fa fa-bar-chart"></i> Gráfico de Barra
                                                </button>
                                                <button type="button" class="btn btn-outline-primary" @click="deffinanceirochart=1">
                                                    <i class="fa fa-pie-chart"></i> Gráfico de Pizza
                                                </button>
                                            </div>                                     
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>                       
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardvendedores) === 1" class="col-md-12" style="margin-top: 10px;">
                            <div class="card shadow h-100" style="background-color: rgba(255, 255, 255, 0.194); margin: 0; padding: 0;">
                                <div class="card-header card-dash">
                                    <span style="font-size: 18px!important;" class="tit-card-dash">Resumo vendedores</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <graficopie v-show="defvendedoreschart===0" 

                                                             :subtitulo="''"
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendasvendedores"
                                                            :dados="dadosvendedores"
                                                            :visualizarlegenda="false"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>
                                            <graficobarra v-show="defvendedoreschart===1" :titulo="''"
                                                            :agrupamento="legendasvendedores"
                                                            :series="dadosvendedores"
                                            ></graficobarra>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="btn-group d-flex justify-content-center" role="group" style="margin-top: 10px;">
                                                <button type="button" class="btn btn-outline-primary" @click="defvendedoreschart=1">
                                                    <i class="fa fa-bar-chart"></i> Gráfico de Barra
                                                </button>
                                                <button type="button" class="btn btn-outline-primary" @click="defvendedoreschart=0">
                                                    <i class="fa fa-pie-chart"></i> Gráfico de Pizza
                                                </button>
                                            </div>                                     
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>                        
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardrecursos) === 1" class="col-md-12" style="margin-top: 10px;">
                            <div class="card shadow h-100" style="background-color: rgba(255, 255, 255, 0.194); margin: 0; padding: 0;">
                                <div class="card-header card-dash">
                                    <span style="font-size: 18px!important;" class="tit-card-dash">Recursos financeiros</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>Conta</th>
                                                    <th>Saldo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in lstcontasfluxo" :key="index">
                                                    <td>{{ item.descricao }}</td>
                                                    <td>{{ mtdformataqtddecimal(parseFloat(item.saldo)) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>                    
                        </div>                       
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-12" style="margin-top: 10px; margin-bottom: 10px;">
                    <div class="row">
                        <div v-show="parseInt(usuariologado.cardcompra) === 1" class="col-12" style="margin-top: 0px;">
                            <div class="card shadow h-100" style="background-color: rgba(255, 255, 255, 0.194); margin: 0; padding: 0;">
                                <div class="card-header card-dash">
                                    <span style="font-size: 18px!important;" class="tit-card-dash">Faturamento diário</span>
                                </div>
                                <div class="dvrodaperelatorios grafico-line-faturamento">
                                    <div class="col-md-12 border-top" style="padding-top: 0px;">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 0px;">
                                                <div class="col-md-12" style="margin-top: 0px">
                                                    <graficoline :titulo="''"
                                                                    :agrupamento="agrupamentograficoline"
                                                                    :series="seriesgraficoline"
                                                    ></graficoline>
                                                </div>                 
                                            </div>
                                        </div>
                                    </div>    
                                </div>
                            </div>                    
                        </div>                        
                    </div>
                </div>
                <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="card-body card-tarefas">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="col-md-12 text-center" style="padding-top: 15px;">
                                                    <span style="color: white; font-size: 18px;">Melhore seu <strong>desempenho</strong> gerênciando suas <strong>tarefas</strong>!</span>                                                    
                                                </div>               
                                            </div>
                                        </div>
                                        <div class="col-md-4 text-center" style="margin-top: 25px;">
                                            <i class="fa fa-tasks" style="color: white; font-size: 38px;"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash" style="padding-top: 7px!important; padding-bottom: 7px!important;">
                                    <div class="row">
                                        <div class="col-5 col-sm-5 col-md-4" style="margin-top: 5px!important;">
                                            <span class="tit-card-dash">Minhas tarefas</span>
                                        </div>
                                        <div class="col-7 col-sm-7 col-md-8 col-lg-8 text-right">
                                            <select name="sbsituacaotarefas" class="form-control form-control-sm selectpicker" id="sbsituacaotarefas" @change="mtdresultadofaturamento()" multiple data-actions-box="true">
                                                <option data-content="<span class='badge badge-primary bdg-digitacao bgd-st-tarefa'>Em dia</span>" value="0"></option>
                                                <option data-content="<span class='badge badge-primary bdg-enviada bgd-st-tarefa'>Atrasadas</span>" value="2"></option>
                                                <option data-content="<span class='badge badge-primary bdg-autorizada bgd-st-tarefa'>Finalizadas</span>" value="1"></option>
                                            </select>
                                        </div>                                        
                                    </div>
                                </div>
                                <div class="card-body" style="background: #f8f9fc26; padding-top: 0px; padding-bottom: 18px; height: 310px; overflow:auto;">
                                    <div class="row">
                                        <div v-show="lsttarefas.length > 0" class="col-md-12">
                                            <div v-for="(tarefa, indice) in lsttarefas" :key="indice" class="card card-tarefa" style="margin-top: 15px;" @click.prevent="mtdgerenciartarefa(tarefa.id)">
                                                <div class="card-body" style="padding: 10px;">
                                                    <div class="row">
                                                        <div class="col-12" style="margin-bottom: 15px;">
                                                            <template v-if="parseInt(tarefa.sttarefa) === 1">
                                                                <span class="span-status-tarefa tarefa-finalizada text-center" title="Tarefa finalizada">
                                                                    <i class="fa fa-calendar-check-o icone-status-tarefa"></i>
                                                                </span>
                                                            </template>
                                                            <template v-else-if="parseInt(tarefa.sttarefa) === 0 && mtddatatarefamenor(tarefa.dtvisualizar)">
                                                                <span class="span-status-tarefa tarefa-normal text-center" title="Tarefa em dia">
                                                                    <i class="fa fa-lightbulb-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>
                                                            <template v-else>
                                                                <span class="span-status-tarefa tarefa-atrasada text-center" title="Tarefa atrasada">
                                                                    <i class="fa fa-clock-o icone-status-tarefa"></i>
                                                                </span>                                                                
                                                            </template>                                                            
                                                            <h5 class="tit-tarefa" v-bind:title="tarefa.titulo">{{ tarefa.titulo }}</h5>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="dv-cal"><i class="fa fa-calendar" style="font-size: 12px; color: #aaaaaa;"></i></div>
                                                            <span class="tit-data">{{ mtdformadardataextenso(mtdtransformadata(tarefa.dtvisualizar+'T00:00:00')) }}</span>
                                                        </div>
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <div v-if="tarefa.checklist.length > 0" class="progress">
                                                                <div class="progress-bar pb-tarefa" v-bind:style="{width: tarefa.concluida + '%'}" title="Percentual de conclusão baseado na checklist">{{ tarefa.concluida }}%</div>
                                                            </div>                                                            
                                                        </div>                                                        
                                                        <div class="col-12 text-right" style="margin-top: 8px;">
                                                            <template v-for="(participante, indicep) in tarefa.participantes">
                                                                <img v-if="parseInt(participante.marcado) === 1" :key="indicep" v-bind:src="pathfotos+participante.foto" class="img-usutarefa" data-toggle="tooltip" v-bind:title="participante.nomeusu">
                                                            </template>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                             
                                        </div>
                                        <button type="button" class="btn btn-primary btn-purple" id="btnovatarefa" title="Adicionar nova tarefa" @click.prevent="mtdnovatarefa()"><i class="fa fa-plus"></i></button>                                        
                                    </div>                                    
                                </div>
                            </div>                    
                        </div>                        
                    </div>    
                </div> -->
                <!-- <div v-show="parseInt(usuariologado.cardcompra) === 1" class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">                   
                        <div  class="col-md-12" style="margin-top: 5px; margin-bottom: 15px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Demonstrativos de compras</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <graficopie  	:titulo="''"
                                                            :subtitulo="''"
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendapedcompra"
                                                            :dados="dadospedcompra"
                                                            :visualizarlegenda="false"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>
                                        </div>
                                        <div class="col-md-12">
                                            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px;">
                                                <li v-for="(item, indice) in dadospedcompra" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.media)) }}%)
                                                    </span>
                                                </li>
                                                <li class="li-item-card-dash" style="height: 15px;">
                                                    <span class=""><b>TOTAL COMPRAS</b></span>
                                                    <span class="" style="float: right;"><b>{{mtdformatavalordecimal(parseFloat(totalpedcompra))}}</b></span>
                                                </li>    
                                            </ul>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                    
                        </div>  
                    </div>    
                </div> -->
                <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                    <div class="row">
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="card">
                                <div class="card-header card-dash">
                                    <span class="tit-card-dash">Picos de venda mais intenso <span style="color: #0acf97; font-weight: bold;">{{ hrmaior }}:00</span>.</span>
                                    <span class="tit-card-dash" style="float: right; font-weight: 300!important; font-size: 12px!important;"><i class="fa fa-calendar"></i> {{ displayperiodo }} </span>
                                </div>
                                <div class="card-body" style="padding-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <ul class="lista-dia-semana-dash text-center">
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 2 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(2)">SEG</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 3 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(3)">TER</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 4 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(4)">QUA</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 5 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(5)">QUI</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 6 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(6)">SEX</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 7 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(7)">SAB</li>
                                                <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 1 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(1)">DOM</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12">
                                            <graficobarra :titulo="''"
                                                            :agrupamento="agrupamentohoras"
                                                            :series="agrupamentoquantidades"
                                            ></graficobarra>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>                    
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- Modal para definição do período para a dashboard -->
        <div class="modal fade" id="mddefinirperiododash" tabindex="-1" role="dialog" aria-labelledby="definirperiododashLabel" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="definirperiododashLabel"><i class="fa fa-calendar"></i> Definição de período</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>								
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>																			
                                </div>
                            </div>                   
                        </div>               
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-green btn-sm" @click.prevent="mtdresultadofaturamento()" data-dismiss="modal"><i class="fa fa-check"></i> Aplicar período</button>
                    </div>
                </div>
            </div>
        </div>              
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
import * as moment from 'moment';
import GraficoPie from '../components/cmpgraficopie.vue';
import GraficoDoughnut from '../components/cmpgraficodoughnut.vue';
import RotinasTarefa from '../components/cmprotinastarefa.vue';
import GraficoBarra from '../components/cmpgraficobarra.vue';
import Graficoline from '../components/cmpgraficoline.vue'
export default {
    name: 'principal',
		components:{
            'graficopie'		: GraficoPie,
            'graficodoughnut'   : GraficoDoughnut,
            'graficobarra'      : GraficoBarra,
            'rotinastarefa'     : RotinasTarefa,
            'graficoline'       : Graficoline
		},
		data: function() {
			return {    
                pathfotos               : this.$store.state.configpaths.pathimagens,
                patharquivos            : this.$store.state.configpaths.pathtarefas,//diretório dos arquivos das tarefas
                lstresultadofaturamento : [],
                mediafaturamento        : 0,
                displayperiodo          : '',
                legendasfinanceiro      : [],
                dadosfinanceiro         : [],
                legendasvendedores      : [],
                dadosvendedores         : [],
                dadospedcompra          : [],
                legendapedcompra        : [],

                agrupamentograficoline  : [],
                seriesgraficoline       : [], 

                agrupamentohoras        : [],
                agrupamentoquantidades  : [],
                hrmaior                 : 0,
                totalpedcompra          : 0,
                totalfin                : 0,
                visualizartop5          : 0,//0 - Valor, 1 - Quantidade
                lsttop5pro              : [],
                lsttop5provl            : [],
                lsttop5proqtd           : [],
                lsttarefas              : [],
                pdtini                  : moment().format('01/MM/YYYY'),
                pdtfim                  : moment().endOf('month').format('DD/MM/YYYY'),//moment().format('DD/MM/YYYY'),
                diaselecionado          : 1,
                deffinanceirochart      : 0,
                defvendedoreschart      : 0,

                vpedidosfat       : 0,
                vpedidosabertos   : 0,
                qtdabertos        : 0,
                tdcancelados      : 0,
                lstcontasfluxo    : [],

                //variáveis para manipulação das tarefas
                optarefa                : 0,
                idtarefa                : 0,
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }                
            }
        },
		methods:{
            gerarMensagemDeBoasVindas() {
                
                var nome = this.$store.state.usuario.nome;
                
                // Obter a hora atual
                var horaAtual = new Date().getHours();

                // Definir as mensagens e emojis correspondentes aos horários
                var mensagem, emoji;

                if (horaAtual >= 5 && horaAtual < 12) {
                    mensagem = `Bom dia, ${nome}!`;
                    emoji = "☀️";
                } else if (horaAtual >= 12 && horaAtual < 18) {
                    mensagem = `Boa tarde, ${nome}!`;
                    emoji = "🌤️";
                } else {
                    mensagem = `Boa noite, ${nome}!`;
                    emoji = "🌙";
                }

                // Retornar a mensagem de boas-vindas com o emoji correspondente
                return `${mensagem} ${emoji}`;
            },

            mtdisdecimal(num){
                return util.isDecimal(num);
            },
            mtdformataqtddecimal(val){
                return util.formatavalordecimais(val ,3);
            },
            mtddatatarefamenor(datatarefa){
                return util.datamenor(datatarefa);
            },
            mtdformadardataextenso(data, mostrahr) {
                if (!mostrahr) {
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00');
                }else{
                    let vdthr = data.split('T');
                    let vhr   = vdthr[1].split(':');
                    return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
                }
            },
            mtdtransformadata: function(dttrasnf){
                return util.formatadatahrdb(dttrasnf);
            },                        
            mtdmesextenso(mes){
                switch (parseInt(mes)) {
                    case 1:
                        return 'JANEIRO'
                        break;
                    case 2:
                        return 'FEVEREIRO'
                        break;
                    case 3:
                        return 'MARÇO'
                        break;
                    case 4:
                        return 'ABRIL'
                        break;     
                    case 5:
                        return 'MAIO'
                        break;     
                    case 6:
                        return 'JUNHO'
                        break;     
                    case 7:
                        return 'JULHO'
                        break;                                                                                                                           
                    case 8:
                        return 'AGOSTO'
                        break;     
                    case 9:
                        return 'SETEMBRO'
                        break;     
                    case 10:
                        return 'OUTUBRO'
                        break;     
                    case 11:
                        return 'NOVEMBRO'
                        break;                                                                                 
                    case 12:
                        return 'DEZEMBRO'
                        break;                        
                }
            },
			mtdformatavalordecimal(valor){
				return util.formatarvalor(valor, '');
            },
            mtdmediafaturados(){
                let mediafat = 0;
                for (let i = 0; i < this.lstresultadofaturamento.length; i++) {                    
                    if (parseInt(this.lstresultadofaturamento[i].stpedido) === 1) {
                        mediafat = this.lstresultadofaturamento[i].totalpedidos / this.lstresultadofaturamento[i].qtdpedidos;
                    }                    
                }
                return mediafat;
            }, 
            mtdremoveatrasadas(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 2){
                        return false;
                    }                       
                }
                return true;
            },   
            mtdremoveemdia(){
                let tarefas = $('#sbsituacaotarefas').selectpicker('val');
                for (let i = 0; i < tarefas.length; i++) {
                    if (parseInt(tarefas[i]) === 0){
                        return false;
                    }                       
                }
                return true;
            },   
            mtdrelatoriomapavendas(){

                let vself   = this;
                let filtro  = ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                let lstmapavendas = [];
				
                let loader      			= vself.$loading.show();
                let parametros  			= [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'mapavendas'},
                    {parametro: 'agrupamento',      valor : 0},
                    {parametro: 'filtro', 	        valor : filtro},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    lstmapavendas       = response.data.agrupamento;

                    //gera os dados para o gráfico de linha custo/venda
                    vself.agrupamentograficoline = util.gerarseriegrafico(lstmapavendas, 'agrupamento');
                    let seriecusto = {
                        name: 'Custo',
                        type: 'line',
                        data: util.gerarseriegrafico(lstmapavendas, 'totalcusto')
                    };
                    let serievenda = {
                        name: 'Venda',
                        type: 'line',
                        data: util.gerarseriegrafico(lstmapavendas, 'totalvenda')
                    };                    
                    vself.seriesgraficoline = [];
                    vself.seriesgraficoline.push(seriecusto);
                    vself.seriesgraficoline.push(serievenda);

                    loader.hide();		
                }).catch(function (response) {
                    lstmapavendas   = [];
                    
                    loader.hide();
                });    
            },              
            mtdresultadofaturamento(){
                this.mtdrelatoriomapavendas()
                var vself           = this;
                vself.pathfotos     = vself.$store.state.configpaths.pathimagens;
                let loader          = vself.$loading.show();
                let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                let filtrotarefas   = '';
                //let filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.dttarefa between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                if (vself.mtdremoveatrasadas()){
                    filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+')';                
                }else{
                    if ($('#sbsituacaotarefas').selectpicker('val').length > 0){
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa in ('+$('#sbsituacaotarefas').selectpicker('val')+', 0)';                
                    }else{
                        filtrotarefas   = ' and pt.idusuario='+vself.$store.state.usuario.id+' and t.sttarefa < 0';                                        
                    }
                }
                let parametros      = [
                    {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'dash'},
                    {parametro: 'periodo',      valor : periodo},
                    {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
                    {parametro: 'filtrotarefas',valor : filtrotarefas},//' and t.sttarefa=0'},
                    {parametro: 'patharquivos', valor : vself.patharquivos},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    vself.lstresultadofaturamento = response.data.mediafaturamento;
                    vself.lsttop5provl            = response.data.top5provl;
                    vself.lsttop5proqtd           = response.data.top5proqtd;
                    vself.lsttop5pro              = vself.lsttop5provl;
                    vself.lsttarefas              = [];
                    let lsttmp                    = JSON.parse(JSON.stringify(response.data.tarefas));
                    

                    vself.vpedidosfat             = response.data.vpedidosfaturados
                    vself.vpedidosabertos         = response.data.vpedidosabertos
                    vself.qtdabertos              = response.data.qtdabertos
                    vself.qtdcancelados           = response.data.qtdcancelados

                    vself.lstcontasfluxo          = response.data.contasfluxo

                    console.log(vself.lstcontasfluxo)
                    if (vself.mtdremoveatrasadas()){
                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                vself.lsttarefas.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                vself.lsttarefas.push(lsttmp[x]);
                            }                            
                        }
                    }else{
                        vself.lsttarefas          = lsttmp;
                    }

                    if (vself.mtdremoveemdia()){
                        lsttmp           = JSON.parse(JSON.stringify(vself.lsttarefas));
                        vself.lsttarefas = [];

                        for (let x = 0; x < lsttmp.length; x++) {
                            if (parseInt(lsttmp[x].sttarefa) === 1){
                                vself.lsttarefas.push(lsttmp[x]);
                            }else if (parseInt(lsttmp[x].sttarefa) === 0 && !vself.mtddatatarefamenor(lsttmp[x].dtvisualizar)){
                                vself.lsttarefas.push(lsttmp[x]);
                            }                            
                        }
                    }                

                    vself.totalfin = parseFloat(response.data.areceber) + parseFloat(response.data.recebido) + parseFloat(response.data.apagar) + parseFloat(response.data.pago);
                    vself.dadosfinanceiro = [
                        {value: parseFloat(response.data.areceber), name: 'À RECEBER',  media : parseFloat(response.data.areceber) > 0 ? parseFloat(response.data.areceber) / vself.totalfin * 100 : 0},
                        {value: parseFloat(response.data.recebido), name: 'RECEBIDOS',  media : parseFloat(response.data.recebido) > 0 ? parseFloat(response.data.recebido) / vself.totalfin * 100 : 0},                        
                        {value: parseFloat(response.data.apagar),   name: 'À PAGAR',    media : parseFloat(response.data.apagar) > 0 ? parseFloat(response.data.apagar) / vself.totalfin * 100 : 0},
                        {value: parseFloat(response.data.pago),     name: 'PAGOS',      media : parseFloat(response.data.pago) > 0 ? parseFloat(response.data.pago) / vself.totalfin * 100 : 0}                   
                    ];


                    ///pedcompra pie 
                    vself.totalpedcompra = parseFloat(response.data.digitacao) + parseFloat(response.data.aguardando) + parseFloat(response.data.entregue) + parseFloat(response.data.cancelado);
                    vself.dadospedcompra = [
                        {value: parseFloat(response.data.digitacao), name: 'EM DIGITAÇÃO',  media : parseFloat(response.data.digitacao) > 0 ? parseFloat(response.data.digitacao) / vself.totalpedcompra * 100 : 0},
                        {value: parseFloat(response.data.aguardando), name: 'AGUARDANDO',  media : parseFloat(response.data.aguardando) > 0 ? parseFloat(response.data.aguardando) / vself.totalpedcompra * 100 : 0},                        
                        {value: parseFloat(response.data.entregue),   name: 'ENTREGUE',    media : parseFloat(response.data.entregue) > 0 ? parseFloat(response.data.entregue) / vself.totalpedcompra * 100 : 0},
                        {value: parseFloat(response.data.cancelado),  name: 'CANCELADO',      media : parseFloat(response.data.cancelado) > 0 ? parseFloat(response.data.cancelado) / vself.totalpedcompra * 100 : 0}                   
                    ];
                    ///fim

                    vself.dadosvendedores    = response.data.vendedores;
                    vself.legendasfinanceiro = util.gerardadoslegendagrafico(vself.dadosfinanceiro);
                    vself.legendasvendedores = util.gerardadoslegendagrafico(vself.dadosvendedores);
                    vself.legendapedcompra   = util.gerardadoslegendagrafico(vself.dadospedcompra);
                    vself.mediafaturamento   = vself.mtdmediafaturados();
                    vself.mtdmostrapicovendas(response.data.picovendas, util.diasemanaintmysql());
                    loader.hide();											
                }).catch(function (response) {
                    vself.lstresultadofaturamento = [];
                    loader.hide();
                });                
            },
            mtdmudatop5(){
                this.visualizartop5 = parseInt(this.visualizartop5) === 0 ? 1 : 0;
                this.lsttop5pro     = parseInt(this.visualizartop5) === 0 ? this.lsttop5provl : this.lsttop5proqtd;
            },
            mtdnovatarefa(){
                this.optarefa = 0;
                this.idtarefa = 0;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);
            },
            mtdgerenciartarefa(idtarefa){
                this.optarefa = 1;
                this.idtarefa = idtarefa;
                let payload = {
                    abrirtela    : true			
                };
                this.$store.commit('ROTINA_TAREFAS_CHANGE',payload);                
            },
            mtdpicosvenda(diasemana){
                var vself           = this;
                let loader          = vself.$loading.show();
                let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                let parametros      = [
                    {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'picovendas'},
                    {parametro: 'periodo',      valor : periodo},
                    {parametro: 'diasemana',    valor : diasemana}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    loader.hide();							
                    vself.mtdmostrapicovendas(response.data.picovendas, diasemana);                                       				                    
                }).catch(function (response) {
                    loader.hide();
                });                                
            },
            mtdmostrapicovendas(picovendas, diasemana){
                let vself = this;
                vself.diaselecionado = diasemana;
                vself.mtdhoramaiorquantidade(picovendas);
                vself.agrupamentohoras          = [];                            
                vself.agrupamentoquantidades    = [];                                        				
                let agr1 = [];
                let agr2 = [];
                if (picovendas.length > 0){
                    for (let i = 0; i < picovendas.length; i++) {
                        picovendas[i];
                        agr1.push(picovendas[i].hora+':00');                            
                        agr2.push(picovendas[i].quantidade);
                    }
                }
                vself.agrupamentohoras          = agr1;                            
                vself.agrupamentoquantidades    = agr2;                
            },
            mtdhoramaiorquantidade(arr) {            
                let maiorQuantidade = 0;
                let horaMaiorQuantidade = "";

                for (let i = 0; i < arr.length; i++) {
                    const quantidade = parseInt(arr[i].quantidade);
                    if (quantidade > maiorQuantidade) {
                    maiorQuantidade = quantidade;
                    horaMaiorQuantidade = arr[i].hora;
                    }
                }
                this.hrmaior = horaMaiorQuantidade;
                // o código seguinte pega tanto a maior quanto a menor
                // let arrt = JSON.parse(JSON.stringify(arr));
                // arrt.sort(function(a, b) {
                //     var quantidadeA = parseInt(a.quantidade);
                //     var quantidadeB = parseInt(b.quantidade);
                    
                //     if (quantidadeA < quantidadeB) {
                //         return 1;
                //     } else if (quantidadeA > quantidadeB) {
                //         return -1;
                //     } else {
                //         return 0;
                //     }
                // });
                // this.hrmaior = arr[0].hora;                
                // this.hrmenor = arr[arr.length - 1].hora;
            }        
        },
        mounted: function () {             
            $('#mddefinirperiododash').on('shown.bs.modal', function () {
                $('#eddtini').focus();
            }); 
            $('#sbsituacaotarefas').selectpicker({
                noneResultsText : 'Sem resultados',
                noneSelectedText: 'Nenhuma selecionada',
                selectAllText   : 'Todas',
                deselectAllText : 'Nenhuma'

            });
            //$('#sbsituacaotarefas').selectpicker('selectAll');//Seleciona todas as tarefas                       
            $('#sbsituacaotarefas').selectpicker('val', ['0', '2']);//Seleciona apenas as em dia e as atrasadas
            util.atzverificalib(this, true);
            if (this.usuariologado.id !== null){
                this.mtdresultadofaturamento();     
            }                    
        },
        computed:{
            telatarefa(){//variável para verificar se o usuário fechou o modal das tarefas
                return this.$store.state.rotinatarefas.abrirtela;                
            },
            usuariologado(){
                return this.$store.state.usuario;
            }              
        },
    watch:{
        telatarefa(val){//atualiza os dados da dashboard quando o usuário fecha a tela da tarefa
            if (!val){
                this.mtdresultadofaturamento();
            }               
        },
        usuariologado(){
            this.mtdresultadofaturamento();
        },
        lstcontasfluxo(){
            let vself  = this;
            let mesini = vself.pdtini.substring(3,5);
            let mesfim = vself.pdtfim.substring(3,5);
            let anoini = vself.pdtini.substring(6,10);
            let anofim = vself.pdtfim.substring(6,10);
            if ((parseInt(mesini) === parseInt(mesfim)) && (parseInt(anoini) === parseInt(anofim))){
                vself.displayperiodo = vself.pdtini.substring(0, 2) + ' - ' + vself.pdtfim.substring(0, 2) + ' ' + vself.mtdmesextenso(vself.pdtini.substring(3,5)) + ' ' + vself.pdtini.substring(6, 10);
            }else{
                vself.displayperiodo = vself.pdtini +' à '+vself.pdtfim;
            }
        }
    }        
}
</script>
<style>
    .draco-dash-shell{
        margin-top: 4px;
    }
    .draco-dash-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        border: 1px solid #ddd3f0;
        border-top: 4px solid #5c3ca0;
        border-radius: 12px;
        padding: 10px 12px;
        margin-bottom: 6px;
        background: #ffffff;
        box-shadow: 0 8px 20px rgba(51, 37, 80, 0.08);
    }
    .draco-dash-header-main{
        min-width: 0;
    }
    .draco-dash-kicker{
        display: block;
        font-size: 0.68rem;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        color: #6a6290;
        font-weight: 700;
    }
    .draco-dash-title{
        color: #404a5d;
        margin: 1px 0 0 0;
        font-weight: 700;
        font-size: 1.06rem;
    }
    .draco-dash-header-actions{
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: flex-end;
    }
    .draco-dash-periodo{
        padding: 5px 10px;
        border-radius: 999px;
        font-size: 0.82rem;
        font-weight: 700;
        color: #3f4c62;
        background: #f3f6fb;
        border: 1px solid #dde5f3;
        white-space: nowrap;
    }
    .draco-dash-btn-periodo{
        border-radius: 10px !important;
        border: 1px solid #c9b9ea !important;
        background: #f4ecff !important;
        color: #4f337c !important;
        font-weight: 700 !important;
        padding: 0.38rem 0.72rem !important;
        box-shadow: 0 6px 14px rgba(74, 46, 123, 0.12);
        white-space: nowrap;
    }
    .draco-dash-btn-periodo:hover{
        filter: brightness(1.04);
    }
    .card-dash{
        height: 45px;
        padding: 10px 15px!important;
        background: white!important;
        border-bottom: 1px solid #00000020!important;        
    }
    .tit-card-dash{
        color: #666666!important;
        font-weight: 500!important;        
    }
    .li-item-card-dash{
        list-style-type: none;
    }
    .txt-item-card-dash{
        font-size: 12px;
        color: #666666;
        font-weight: 700;
    }
    .txt-item-card-dash-grafico{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }
    .txt-item-card-dash-top5-desc{
        font-size: 10px;
        color: #666666;
        font-weight: 600; 
        max-width: 280px!important; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;                
    }   
    .txt-item-card-dash-top5-val{
        font-size: 10px;
        color: #666666;
        font-weight: 600;        
    }    
    .btn-muda-top5{
        margin-right: 5px!important;
        font-size: 10px!important;
        width: 20px!important;
        height: 20px!important;
        padding: 2px!important;
        margin-top: -5px!important;        
    }
    .card-tarefas{
        min-height: 154px!important;
        /* background: #727cf5!important; */
        background-image: linear-gradient(to right, #19218b, #2029a2, #2731b9, #2e3ad1, #3543e9);
        
        border-radius: 3px!important;
    }
    .pb-tarefa{
        background: #727cf5!important;
        font-size: 10px!important;
    }
    .bgd-st-tarefa{
        width: 73px;
    }
    .btn-light{
        background: #fbfbfb!important;
    }   
    .dia-selecionado{
        border-bottom: 4px solid #0acf97!important;
    } 
    @media (max-width: 576px) {
        .grafico-individual .echarts {
            width: 300px;
            height: 200px;
        }        
        .grafico-line-faturamento .echarts{
            width: 300px;
            height: 200px;        
        }        
    }  
    @media (min-width: 577px) {
        .grafico-individual .echarts {
            width: 500px;
            height: 200px;
        }        
        .grafico-line-faturamento .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        .grafico-individual .echarts {
            width: 1024px;
            height: 200px;
        }       
        .grafico-line-faturamento .echarts{
            width: 1024px;
            height: 200px;        
        }        
    } 
    .bgverde {
        background-color: #198754 !important; /* Verde padrão do Bootstrap */
        border: #198754 !important;
      }
      
      .bgvermelho {
        background-color: #DC3545 !important; /* Vermelho padrão do Bootstrap */
        border: #DC3545 !important;
      }
      
      .bgamarelo {
        background-color: #755a07 !important; /* Amarelo padrão do Bootstrap */
        border: #755a07 !important;
      }
      .mg5{
        margin: 0 !important;
      }
    @media (max-width: 768px) {
        .draco-dash-header{
            flex-direction: column;
            align-items: flex-start;
        }
        .draco-dash-header-actions{
            width: 100%;
            justify-content: flex-start;
        }
    }
</style>
